import { abstractLitigationCaseValidators } from "../AbstractLitigationCase/abstractLitigationCaseValidators";


export const employmentContractValidators = {
  ...abstractLitigationCaseValidators,
};